import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'utils/modifiedTranslation';
import MuiButton from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useQuestionnaireData, useUpdateQuestionnaireData } from '../../context';
import { FILE_UPLOAD, SELECT_FROM_LIST } from './constants';
import { useStyles } from './subPageSwitcherStyles';

const subPagesData = (isMobile) => ([
  {
    value: SELECT_FROM_LIST,
    label: 'questionnaire.biomarkers_question.subpage_switcher.search',
    title: `questionnaire.biomarkers_question.subpage_title.${!isMobile ? 'desktop_search' : 'search'}`,
    subTitle: 'questionnaire.biomarkers_question.subpage_subtitle.search',
    parentSubTitle: 'questionnaire.biomarkers_question.subpage_parent_subtitle.search',
  },
  {
    value: FILE_UPLOAD,
    label: 'questionnaire.biomarkers_question.subpage_switcher.upload',
    title: `questionnaire.biomarkers_question.subpage_title.${!isMobile ? 'desktop_upload' : 'upload'}`,
    subTitle: 'questionnaire.biomarkers_question.subpage_subtitle.upload',
    parentSubTitle: 'questionnaire.biomarkers_question.subpage_parent_subtitle.upload',
    style: {
      backgroundColor: '#fff', color: '#FF8C69', border: '1px solid #FF8C69', fontWeight: '700',
    },
  },
]);

export const SubPageSwitcher = ({
  onSubPageChange, setTitle, isMobile, setSubTitle, handleNext, hideGeneticSkipBtn,
}) => {
  const { embedded } = useQuestionnaireData();
  const updateQuestionnaireData = useUpdateQuestionnaireData();
  const { appConfiguration: { providerSpecific } = {} } = useSelector((state) => state) ?? {};
  const classes = useStyles({ provider: providerSpecific?.code, embedded });
  const { t } = useTranslation();

  useEffect(() => {
    updateQuestionnaireData((currentValue) => ({ ...currentValue, showNextButton: false }));
    return () => {
      updateQuestionnaireData((currentValue) => ({ ...currentValue, showNextButton: true }));
    };
  }, [updateQuestionnaireData]);

  return (
    <div className={classes.root}>
      {
        subPagesData(isMobile).map(({
          label, value, title, subTitle, style, parentSubTitle,
        }, index) => {
          const onButtonClick = () => {
            if (value !== FILE_UPLOAD) {
              setTitle(title);
              setSubTitle(parentSubTitle);
            }

            onSubPageChange(value);
          };
          return (
            <div key={index} className={classes.wrapper}>
              <Typography variant="h4" className={classes.title} dangerouslySetInnerHTML={{ __html: t(subTitle) }} />
              <MuiButton
                className={classes.button}
                onClick={onButtonClick}
                style={style}
              >
                {t(label)}
              </MuiButton>
            </div>
          );
        })
      }
      {!hideGeneticSkipBtn && <p className={classes.skipOnClick} onClick={handleNext}>{t('questionnaire.biomarkers.skip')}</p>}
    </div>
  );
};

SubPageSwitcher.propTypes = {
  onSubPageChange: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  setTitle: PropTypes.func.isRequired,
  setSubTitle: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  hideGeneticSkipBtn: PropTypes.bool.isRequired,
};
